/**
 * Consolida los datos del gráfico sumando todos los períodos en uno solo
 * ⭐ Preserva automáticamente los colores, unidades y estilos de cada indicador
 * * @param {Object} data - Datos del gráfico con múltiples períodos
 * @returns {Object} Datos consolidados con un único período que suma todos los valores
 */
export const consolidateData = (data) => {
    // Validación temprana
    if (!data || !data.datasets || data.datasets.length === 0) {
        return data;
    }

    // Crear un mapa para agrupar por indicador (label)
    // En JS no necesitamos definir la interfaz del objeto acumulador
    const consolidatedMap = {};

    // Procesar cada dataset
    data.datasets.forEach(dataset => {
        const key = dataset.label;

        if (!consolidatedMap[key]) {
            // Primera vez que vemos este indicador
            // ⭐ Los colores ya vienen procesados desde formatDataIndicators
            consolidatedMap[key] = {
                label: dataset.label,
                data: [...dataset.data],
                backgroundColor: dataset.backgroundColor, // ⭐ Preserva el color del JSON
                borderColor: dataset.borderColor, // ⭐ Preserva el color del JSON
                borderWidth: dataset.borderWidth,
                unit: dataset.unit
            };
        } else {
            // Ya existe este indicador, sumar los valores
            // (mantiene los colores del primer dataset encontrado)
            dataset.data.forEach((value, index) => {
                if (consolidatedMap[key].data[index] !== undefined) {
                    consolidatedMap[key].data[index] += value;
                } else {
                    consolidatedMap[key].data[index] = value;
                }
            });
        }
    });

    // Calcular la suma total de todos los períodos para cada indicador
    const consolidatedDatasets = Object.values(consolidatedMap).map(dataset => {
        const total = dataset.data.reduce((sum, val) => sum + val, 0);
        return {
            ...dataset, // ⭐ Spread preserva backgroundColor, borderColor, unit, etc.
            data: [Number(total.toFixed(2))], // Suma redondeada a 2 decimales
        };
    });

    console.log('🔄 Datos consolidados:', {
        originalPeriods: data.labels ? data.labels.length : 0,
        indicators: consolidatedDatasets.length,
        colors: consolidatedDatasets.map(d => ({
            label: d.label,
            color: d.backgroundColor
        }))
    });

    return {
        labels: ['Consolidado'], // Una sola etiqueta para el período consolidado
        datasets: consolidatedDatasets
    };
};